// extracted by mini-css-extract-plugin
export var form = "_dy-0";